import Vue from 'vue'

const state = {
    search: '',
    progress: 'all',
    favorite: 'all',
}

const actions = {
    SET_FILTERS(context, [search, progress, favorite]) {
        context.commit('SAVE_FILTERS', [search, progress, favorite])
    },
}

const mutations = {
    SAVE_FILTERS: (state, [search, progress, favorite]) => {
        Vue.set(state, 'search', search)
        Vue.set(state, 'progress', progress)
        Vue.set(state, 'favorite', favorite)
    }
}

const getters = {
    search: state => {
        return state.search
    },

    progress: state => {
        return state.progress
    },

    favorite: state => {
        return state.favorite
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}